import { render, staticRenderFns } from "./ViewNotesModal.vue?vue&type=template&id=4f3f90c8&scoped=true&"
import script from "./ViewNotesModal.vue?vue&type=script&lang=js&"
export * from "./ViewNotesModal.vue?vue&type=script&lang=js&"
import style0 from "./ViewNotesModal.vue?vue&type=style&index=0&id=4f3f90c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3f90c8",
  null
  
)

export default component.exports